import $ from "jquery";
import React from 'react';
import { Button } from 'semantic-ui-react';
import TextField from '@material-ui/core/TextField';


import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import Server from '../../../functions/server';
import getFormatedDate from '../../../functions/date';

export default class App extends React.Component {

    state = {
        fromDate: '2022-01-23',
        toDate: getFormatedDate(new Date()),
        report: [], taxArray: []
    }

    otherCharge = () => {
        let report = this.state.report;
        let total = 0;
        report.map((c) => {
            if (c.partno == 0 || c.partno == '0') {
                let dnp = this.convertIntoNumber(c.dnp);
                let tax = this.convertIntoNumber(c.tax);
                total = total + (dnp + ((dnp * tax) / 100));
            }
        })
        return total;
    }

    getHsnReport = () => {
        let context = this;
        context.setState({ load: true, message: 'Getting Branchs' });
        $.ajax({
            type: 'POST', data: { 'from_date': context.state.fromDate, 'to_date': context.state.toDate },
            url: Server() + 'purchasegstreport/gethsncodebasedreport.php',
            success: function (data) {
                try {
                    data = JSON.parse(data);
                    context.removeDuplicate(data);
                    context.setState({ load: false, report: data, dialog: true });
                } catch (e) {
                    alert('Error')
                    context.setState({ load: false });
                }
            },
            error: function (e) {
                alert('Try again!!')
                context.setState({ load: false });
            }
        });
    }

    removeDuplicate = (data) => {
        let context = this;
        let taxArray = data.filter((v, i, a) => a.findIndex(t => (t.tax === v.tax && t.partno != 0 && t.partno != '0')) === i);
        taxArray.map((c) => {
            let newArray = [];
            data.map((v) => {
                if (c.tax == v.tax) {
                    newArray.push(v)
                }
            })
            c.report = JSON.stringify(newArray);
        })
        context.setState({ taxArray })
    }

    convertIntoNumber = (value) => {
        try {
            value = Number(value);
        } catch (error) {
            value = 0;
        }
        return value;
    }

    makeDecimalPoints = (value) => {
        try {
            value = value.toFixed(2);
        } catch (error) {
            value = 0;
        }
        return value;
    }


    render() {
        let { dialog, taxArray } = this.state;
        let totalqty = 0; let totaldnp = 0; let IGSTTotal = 0; let SGSTTotal = 0; let overalltotal = 0;
        return (
            <div>
                <Button onClick={this.getHsnReport}>HSNCode Based Report</Button>
                <Dialog fullWidth={true} maxWidth={'lg'}
                    open={dialog} onClose={() => { this.setState({ dialog: false }) }}
                    aria-labelledby="max-width-dialog-title">
                    <DialogTitle id="max-width-dialog-title">HSNCODE BASED REPORT</DialogTitle>
                    <DialogContent>

                        <div style={{ float: 'left', display: 'flex' }}>
                            <TextField label="From" type="date"
                                onChange={(e) => this.setState({ fromDate: e.target.value })}
                                defaultValue={this.state.fromDate} />
                            <TextField style={{ marginLeft: 20 }} label="To" type="date"
                                onChange={(e) => this.setState({ toDate: e.target.value })}
                                defaultValue={this.state.toDate} />
                            <Button variant="contained" color="primary" style={{ marginLeft: 20, marginTop: '1%' }}
                                onClick={this.getHsnReport}>Go</Button>
                        </div>

                        <br />
                        <br />

                        {
                            taxArray.map((c) => {
                                let array = [];
                                try {
                                    array = JSON.parse(c.report);
                                } catch (error) {
                                }
                                return (
                                    <div style={{ marginTop: '2%' }}>
                                        <h3>{'GST' + c.tax + "%"}</h3>
                                        <table width="100%" id="table">
                                            <tr>
                                                <th id="th" style={{ width: '10%' }}>HSN</th>
                                                <th id="th" style={{ width: '5%' }}>QTY</th>
                                                <th id="th" style={{ width: '15%' }}>Taxable Value</th>
                                                <th id="th" style={{ width: '15%' }}>IGST</th>
                                                <th id="th" style={{ width: '15%' }}>CGST</th>
                                                <th id="th" style={{ width: '15%' }}>SGST</th>
                                                <th id="th" style={{ width: '10%' }}>Other</th>
                                                <th id="th" style={{ width: '15%' }}>Total Value</th>
                                            </tr>
                                            {
                                                array.map((v) => {
                                                    let tax = this.convertIntoNumber(v.tax);
                                                    let stock = this.convertIntoNumber(v.stock);
                                                    totalqty = totalqty + stock;
                                                    let dnp = this.convertIntoNumber(v.dnp);
                                                    totaldnp = totaldnp + dnp;
                                                    let GST = ((dnp * tax) / 100);
                                                    let total = dnp + GST;
                                                    overalltotal = overalltotal + total;
                                                    if (v.purchaserstate == v.branchstate) {
                                                        SGSTTotal = SGSTTotal + GST;
                                                    }
                                                    else {
                                                        IGSTTotal = IGSTTotal + GST;
                                                    }
                                                    return (
                                                        <tr>
                                                            <td>{v.hsncode}</td>
                                                            <td>{v.stock}</td>
                                                            <td style={{ textAlign: 'right' }}>{this.makeDecimalPoints(dnp)}</td>
                                                            <td style={{ textAlign: 'right' }}>{v.purchaserstate == v.branchstate ? '' : this.makeDecimalPoints(GST)}</td>
                                                            <td style={{ textAlign: 'right' }}>{v.purchaserstate == v.branchstate ? this.makeDecimalPoints(GST / 2) : ''}</td>
                                                            <td style={{ textAlign: 'right' }}>{v.purchaserstate == v.branchstate ? this.makeDecimalPoints(GST / 2) : ''}</td>
                                                            <td style={{ textAlign: 'right', width: '10%' }}></td>
                                                            <td style={{ textAlign: 'right' }}>{this.makeDecimalPoints(total)}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </table>
                                    </div>
                                )
                            })
                        }

                        <table width="100%" id="table" style={{ marginTop: '2%' }}>
                            <tr>
                                <td style={{ width: '10%', fontWeight: 'bold' }}><b>{'Total'}</b></td>
                                <td style={{ width: '5%', fontWeight: 'bold' }}>{totalqty}</td>
                                <td style={{ textAlign: 'right', width: '15%', fontWeight: 'bold' }}>{this.makeDecimalPoints(totaldnp)}</td>
                                <td style={{ textAlign: 'right', width: '15%', fontWeight: 'bold' }}>{this.makeDecimalPoints(IGSTTotal)}</td>
                                <td style={{ textAlign: 'right', width: '15%', fontWeight: 'bold' }}>{this.makeDecimalPoints(SGSTTotal / 2)}</td>
                                <td style={{ textAlign: 'right', width: '15%', fontWeight: 'bold' }}>{this.makeDecimalPoints(SGSTTotal / 2)}</td>
                                <td style={{ textAlign: 'right', width: '10%', fontWeight: 'bold' }}>{this.otherCharge()}</td>
                                <td style={{ textAlign: 'right', width: '15%', fontWeight: 'bold' }}>{this.makeDecimalPoints(overalltotal + this.otherCharge())}</td>
                            </tr>
                        </table>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { this.setState({ dialog: false }) }}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}


